import { render, staticRenderFns } from "./logistica.vue?vue&type=template&id=4396d94d&"
import script from "./logistica.vue?vue&type=script&lang=js&"
export * from "./logistica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports